import { useProfile } from '../../hooks/useProfile';
import './UserProfile.css';

// 모래시계 개수에 따른 등급 계산
function getRank(hourglassCount: number): string {
  if (hourglassCount < 100) return '모래알';
  if (hourglassCount < 200) return '선인장';
  if (hourglassCount < 400) return '낙타';
  if (hourglassCount < 700) return '오아시스';
  if (hourglassCount < 1200) return '사막의 별';
  if (hourglassCount < 2000) return '모래 폭풍';
  if (hourglassCount < 3000) return '시간의 수호자';
  return '시간의 지배자';
}

export function UserProfile() {
  const { data: profile, isLoading } = useProfile();

  if (isLoading || !profile) {
    return (
      <div className="user-profile">
        <div className="user-profile__avatar user-profile__avatar--loading">⏳</div>
        <div className="user-profile__info">
          <div className="user-profile__name">로딩 중...</div>
          <div className="user-profile__rank">-</div>
        </div>
        <div className="user-profile__hourglass">⏳ 0</div>
      </div>
    );
  }

  const displayName = profile.github_username || '게스트';
  const avatarEmoji = profile.avatar_emoji || '👤';
  const hourglassCount = profile.hourglass_count || 0;
  const rank = getRank(hourglassCount);

  return (
    <div className="user-profile">
      <div className="user-profile__avatar">{avatarEmoji}</div>
      <div className="user-profile__info">
        <div className="user-profile__name">{displayName}</div>
        <div className="user-profile__rank">{rank}</div>
      </div>
      <div className="user-profile__hourglass">
        <span className="user-profile__hourglass-icon">⏳</span>
        <span className="user-profile__hourglass-count">{hourglassCount.toLocaleString()}</span>
      </div>
    </div>
  );
}

